<template>
  <router-link :to="to" class="card-link">
    <div class="card">
      <h1>{{ title }}</h1>
      <p>{{ content }}</p>
    </div>
  </router-link>
</template>

<script>
export default {
  name: 'CardHome',
  props: {
    title: String,
    content: String,
    to: String
  }
}
</script>

<style scoped>
.card-link {
  text-decoration: none;
  color: inherit;
  display: flex;
  flex: 1;
}

.card {
  background-color: #323336;
  border-radius: 20px;
  padding: 1.5rem;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  flex: 1;
}

.card:hover {
  transform: scale(1.05);
  box-shadow: 0 0 20px #00f0ff, 0 0 30px #00f0ff66;
}

.card > h1 {
  margin: 0 0 1rem;
}

.card > p {
  margin: 0;
}
</style>
